import React, { createContext, useContext, useState } from "react";

// Create Context
const CloudProviderContext = createContext();

// Context Provider Component
export const CloudProvider = ({ children }) => {
  const [provider, setProvider] = useState(""); // Default provider

  return (
    <CloudProviderContext.Provider value={{ provider, setProvider }}>
      {children}
    </CloudProviderContext.Provider>
  );
};

// Custom Hook to Access Cloud Provider
export const useCloudProvider = () => useContext(CloudProviderContext);
